import { ElfaConfigurator } from 'models/ElfaConfigurator';
import { ElfaDoorSpec } from 'models/ElfaDoorSpec';

export const doorsKey = 'doors';
export const profileAddonKey = 'elfaprofil';
export const fillingAddonsKey = 'elfafyllning';
export const selectedFillingsKey = 'selectedFillings';
export const widthKey = 'widthMm';
export const profileKey = 'profil';
export const imageBasePath = '/configurator/elfa/';

export interface ResourceTexts {
  fillingModalHeader: string;
  fillingModalSame: string;
  fillingModalClose: string;
  fillingModalOpen: string;
  fillingModalDoorName: string;
}

export const getFillings = (values: { [key: string]: string } | undefined): ElfaDoorSpec[] => {
  const selectedFillingsString = values && values[selectedFillingsKey];
  return selectedFillingsString ? (JSON.parse(selectedFillingsString) as ElfaDoorSpec[]) : [];
};

export const getConfiguratorPrice = (configurator: ElfaConfigurator) => {
  const numDoors = configurator.values && parseInt(configurator.values[doorsKey], undefined);
  let selectedFillings = getFillings(configurator.values);

  if (selectedFillings.length > 0 && numDoors) {
    selectedFillings = selectedFillings.sort((a, b) => (a.doorId > b.doorId ? 1 : -1));
    selectedFillings = selectedFillings.slice(0, numDoors); // Remove unwanted specs.
  }

  const fillingAddons = configurator.elfaAddons[fillingAddonsKey];
  let totalPrice = 0;

  selectedFillings.map(f => {
    const product = fillingAddons.products.find(p => p.productId === f.productId);

    if (product) {
      totalPrice += product.price.presentationPrice;
    }
  });

  return totalPrice;
};
